var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pTokenFrom",
    class: _vm.isMobile && 'wap'
  }, [_vm.form ? _c('div', {
    staticClass: "pTokenFrom-main",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "pTokenFrom-head"
  }, [_c('div', {
    staticClass: "pTokenFrom-head-main inputHover"
  }, [_c('div', {
    staticClass: "btn-up",
    on: {
      "click": _vm.onOpenImgCurrter
    }
  }, [_vm.form.tokenIcon ? [_vm.form.tokenIcon ? _c('img', {
    staticClass: "token-icon",
    attrs: {
      "src": _vm.form.tokenIcon,
      "alt": ""
    }
  }) : _vm._e(), _c('div', {
    staticClass: "up change"
  }, [_c('svg-icon', {
    attrs: {
      "name": "change"
    }
  })], 1)] : [_c('m-img-empty'), _c('div', {
    staticClass: "up"
  }, [!_vm.upImgLoading ? _c('svg-icon', {
    attrs: {
      "name": "icon-up"
    }
  }) : _c('svg-icon', {
    attrs: {
      "name": "loading",
      "spin": ""
    }
  })], 1)]], 2), _c('m-img-cutter', {
    ref: "mImgCurrer",
    attrs: {
      "moveAble": false,
      "rate": "1:1",
      "sizeChange": false,
      "toolBoxOverflow": false,
      "isModal": _vm.imgCutterShow
    },
    on: {
      "cutDown": _vm.cutDown,
      "update:isModal": function ($event) {
        _vm.imgCutterShow = $event;
      },
      "update:is-modal": function ($event) {
        _vm.imgCutterShow = $event;
      }
    }
  })], 1), _c('div', {
    staticClass: "pTokenFrom-head__info"
  }, [_vm._v(" " + _vm._s(_vm.$lang("Upload Token Avatar")) + " "), _vm.vail.tokenIcon ? _c('i', [_vm._v(_vm._s(_vm.vail.tokenIcon))]) : _vm._e(), _c('p', [_vm._v("(.png, .jpg, .gif)")])])]), _c('div', {
    staticClass: "pTokenFrom-from"
  }, [_c('div', {
    staticClass: "pTokenFrom-from__title"
  }, [_vm._v(_vm._s(_vm.$lang("Basic Token Info")))]), _c('div', {
    staticClass: "pTokenFrom-item"
  }, [_c('div', {
    staticClass: "pTokenFrom-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.tokenName,
      expression: "form.tokenName"
    }],
    staticClass: "inputHover",
    class: _vm.vail.tokenName && 'err',
    attrs: {
      "type": "text",
      "placeholder": _vm.$lang('Token Name')
    },
    domProps: {
      "value": _vm.form.tokenName
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "tokenName", $event.target.value);
      }, function ($event) {
        return _vm.vailForm('tokenName');
      }]
    }
  })]), _vm.vail.tokenName ? _c('div', {
    staticClass: "pTokenFrom__error"
  }, [_vm._v(_vm._s(_vm.vail.tokenName))]) : _vm._e()]), _c('div', {
    staticClass: "pTokenFrom-item"
  }, [_c('div', {
    staticClass: "pTokenFrom-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.tokenSymbol,
      expression: "form.tokenSymbol"
    }],
    staticClass: "inputHover",
    class: _vm.vail.tokenSymbol && 'err',
    attrs: {
      "type": "text",
      "placeholder": _vm.$lang('Token Symbol')
    },
    domProps: {
      "value": _vm.form.tokenSymbol
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "tokenSymbol", $event.target.value);
      }, function ($event) {
        return _vm.vailForm('tokenSymbol');
      }]
    }
  })]), _vm.vail.tokenSymbol ? _c('div', {
    staticClass: "pTokenFrom__error"
  }, [_vm._v(_vm._s(_vm.vail.tokenSymbol))]) : _vm._e()]), _c('div', {
    staticClass: "pTokenFrom-item"
  }, [_c('div', {
    staticClass: "pTokenFrom-input"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.tokenDescription,
      expression: "form.tokenDescription"
    }],
    staticClass: "inputHover",
    attrs: {
      "placeholder": _vm.$lang('Description (Optional)')
    },
    domProps: {
      "value": _vm.form.tokenDescription
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "tokenDescription", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "pTokenFrom-item"
  }, [_c('div', {
    staticClass: "pTokenFrom-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.tokenWebsite,
      expression: "form.tokenWebsite"
    }],
    staticClass: "inputHover",
    attrs: {
      "type": "text",
      "placeholder": _vm.$lang('Website (Optional)')
    },
    domProps: {
      "value": _vm.form.tokenWebsite
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "tokenWebsite", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "pTokenFrom-item"
  }, [_c('div', {
    staticClass: "pTokenFrom-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.tokenTelegram,
      expression: "form.tokenTelegram"
    }],
    staticClass: "inputHover",
    class: _vm.vail.tokenTelegram && 'err',
    attrs: {
      "type": "text",
      "placeholder": _vm.$lang('Telegram (Optional)')
    },
    domProps: {
      "value": _vm.form.tokenTelegram
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "tokenTelegram", $event.target.value);
      }, function ($event) {
        return _vm.vailForm('tokenTelegram');
      }]
    }
  })]), _vm.vail.tokenTelegram ? _c('div', {
    staticClass: "pTokenFrom__error"
  }, [_vm._v(_vm._s(_vm.vail.tokenTelegram))]) : _vm._e()]), _c('div', {
    staticClass: "pTokenFrom-item"
  }, [_c('div', {
    staticClass: "pTokenFrom-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.tokenTwitter,
      expression: "form.tokenTwitter"
    }],
    staticClass: "inputHover",
    class: _vm.vail.tokenTwitter && 'err',
    attrs: {
      "type": "text",
      "placeholder": _vm.$lang('Twitter URL (Optional)')
    },
    domProps: {
      "value": _vm.form.tokenTwitter
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "tokenTwitter", $event.target.value);
      }, function ($event) {
        return _vm.vailForm('tokenTwitter');
      }]
    }
  })]), _vm.vail.tokenTwitter ? _c('div', {
    staticClass: "pTokenFrom__error"
  }, [_vm._v(_vm._s(_vm.vail.tokenTwitter))]) : _vm._e()]), _c('div', {
    staticClass: "pTokenFrom-item"
  }, [_c('div', {
    staticClass: "pTokenFrom-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.tokenLeaderTwitter,
      expression: "form.tokenLeaderTwitter"
    }],
    staticClass: "inputHover",
    class: _vm.vail.tokenLeaderTwitter && 'err',
    attrs: {
      "type": "text",
      "disabled": !_vm.leaderEnabled,
      "placeholder": _vm.leaderEnabled ? _vm.$lang('Leader X / Twitter URL or @username (Optional)') : 'coming_soon'
    },
    domProps: {
      "value": _vm.form.tokenLeaderTwitter
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "tokenLeaderTwitter", $event.target.value);
      }, function ($event) {
        return _vm.vailForm('tokenLeaderTwitter');
      }]
    }
  })]), _vm.vail.tokenLeaderTwitter ? _c('div', {
    staticClass: "pTokenFrom__error"
  }, [_vm._v(_vm._s(_vm.vail.tokenLeaderTwitter))]) : _vm._e(), _c('div', {
    staticClass: "fee-ratio-item"
  }, [_vm._m(0), _c('div', {
    staticClass: "fee-ratio-slider",
    class: (!_vm.leaderEnabled || !_vm.form.tokenLeaderTwitter) && 'disabled'
  }, [_c('div', {
    staticClass: "fee-ratio-values"
  }, [_c('span', [_vm._v("Creator "), _c('b', [_vm._v(_vm._s(_vm.form.creatorSharePercent) + "%")])]), _c('span', [_vm._v("Leader "), _c('b', [_vm._v(_vm._s(100 - _vm.form.creatorSharePercent) + "%")])])]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.creatorSharePercent,
      expression: "form.creatorSharePercent",
      modifiers: {
        "number": true
      }
    }],
    style: {
      '--fee-progress': _vm.form.creatorSharePercent + '%'
    },
    attrs: {
      "type": "range",
      "min": "0",
      "max": "100",
      "step": "1",
      "disabled": !_vm.leaderEnabled || !_vm.form.tokenLeaderTwitter
    },
    domProps: {
      "value": _vm.form.creatorSharePercent
    },
    on: {
      "__r": function ($event) {
        _vm.$set(_vm.form, "creatorSharePercent", _vm._n($event.target.value));
      },
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _vm.vail.feeRatio ? _c('div', {
    staticClass: "pTokenFrom__error"
  }, [_vm._v(_vm._s(_vm.vail.feeRatio))]) : _vm._e()])]), _c('div', {
    staticClass: "pTokenFrom-item"
  }, [_c('div', {
    staticClass: "pTokenFrom-info"
  }, [_c('div', {
    staticClass: "pTokenFrom-info__title"
  }, [_vm._v(_vm._s(_vm.$lang("Classic Bonding Curve")))]), _c('div', {
    staticClass: "pTokenFrom-info__intro"
  }, [_vm._v(" " + _vm._s(_vm.$lang(`The bonding curve model is employed, utilizing the formula x×y=k for its calculation. This approach adheres to the best practices of Automated Market Makers (AMMs) and meme token launches. While this method offers simplicity, it also highlights inherent limitations in launches, providing less leverage for achieving sustainable growth.`)) + " ")])])]), _c('div', {
    staticClass: "pTokenFrom-item"
  }, [_c('div', {
    staticClass: "pTokenFrom-info"
  }, [_c('div', {
    staticClass: "pTokenFrom-info__title"
  }, [_vm._v(_vm._s(_vm.$lang("Initial Buy")))]), _c('div', {
    staticClass: "pTokenFrom-item__sub"
  }, [_vm._v("Specify the number of tokens you want to purchase as a privileged buyer")])]), _c('div', {
    staticClass: "pTokenFrom-buy inputHover",
    class: _vm.vail.initBuy && 'err'
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-conversion"
    }
  }), _c('i', [_vm.web3Wallet.currencyIcon ? _c('img', {
    attrs: {
      "src": _vm.web3Wallet.currencyIcon,
      "alt": ""
    }
  }) : _vm._e()]), _c('span', [_vm._v(" " + _vm._s(_vm.web3Wallet.symbol ? _vm.web3Wallet.symbol : "--") + " ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.initBuy,
      expression: "form.initBuy"
    }],
    attrs: {
      "type": "number",
      "placeholder": _vm.$lang('Insert your amount')
    },
    domProps: {
      "value": _vm.form.initBuy
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "initBuy", $event.target.value);
      }, function ($event) {
        return _vm.vailForm('initBuy');
      }]
    }
  })], 1), _vm.initBuyInfo ? _c('div', {
    staticClass: "pTokenFrom__info"
  }, [_vm._v(" You will receive "), _c('span', [_vm._v(_vm._s(this.fmt_th(_vm.initBuyInfo, 6)))]), _vm._v(" " + _vm._s(_vm.form.tokenSymbol) + " ")]) : _vm._e(), _vm.vail.initBuy ? _c('div', {
    staticClass: "pTokenFrom__error"
  }, [_vm._v(_vm._s(_vm.vail.initBuy))]) : _vm._e()]), _c('div', {
    staticClass: "pTokenFrom-item"
  }, [_c('div', {
    staticClass: "pTokenFrom-check hover",
    on: {
      "click": _vm.onCheck
    }
  }, [_c('div', {
    staticClass: "check"
  }, [_vm.form.check ? _c('svg-icon', {
    attrs: {
      "name": "icon-ok"
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "pTokenFrom-check__label"
  }, [_vm._v("I agree to the Wave.fun "), _c('a', {
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.onShowTerms.apply(null, arguments);
      }
    }
  }, [_vm._v("Terms of use")])])]), _vm.vail.check ? _c('div', {
    staticClass: "pTokenFrom__error"
  }, [_vm._v(_vm._s(_vm.vail.check))]) : _vm._e()]), _c('div', {
    staticClass: "pTokenFrom-item"
  }, [_vm.isWallet ? _c('div', {
    staticClass: "btn-token hover",
    on: {
      "click": _vm.onLaunch
    }
  }, [_vm.isBtnLoading ? _c('div', {
    staticClass: "btnLoading",
    class: _vm.isMobile && 'wap'
  }) : [_vm._v(_vm._s(_vm.$lang("Launch Token")) + " ")]], 2) : _c('div', {
    staticClass: "btn-token connect btn",
    on: {
      "click": _vm.doConnect
    }
  }, [_vm._v(_vm._s(_vm.$lang("Connect Wallet")))])]), _c('div', {
    staticClass: "pTokenFrom-item"
  }, [_c('div', {
    staticClass: "pTokenFrom-deploy"
  }, [_vm._v(_vm._s(_vm.$lang("Deploy Fee")) + ": "), _c('em', {
    domProps: {
      "innerHTML": _vm._s(_vm.web3Wallet.createFee.label)
    }
  }), _vm._v(" " + _vm._s(_vm.web3Wallet.symbol ? _vm.web3Wallet.symbol : "--"))])])])]) : _vm._e(), _c('pop-terms', {
    attrs: {
      "show": _vm.popTermsShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popTermsShow = $event;
      }
    }
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pTokenFrom-info"
  }, [_c('div', {
    staticClass: "pTokenFrom-info__title"
  }, [_vm._v("Trading Fee Split")]), _c('div', {
    staticClass: "pTokenFrom-item__sub"
  }, [_vm._v("Only applies when a Leader Twitter account is configured.")])]);
}];
export { render, staticRenderFns };